import ApiClientMobile from 'services/api/ApiClientMobile';

import { ISendRetenoAnalyticsRequest } from './types';

class AnalyticsApi {
    sendRetenoAnalyticsEvent = async <Data = ISendRetenoAnalyticsRequest>(
        payload: Data
    ): Promise<Partial<Response>> => {
        return await ApiClientMobile.post<Data, Response>('reteno/events', payload);
    };
}

export default AnalyticsApi;
